import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IUser } from './user.model';
import { environment } from '../../../environments/environment';
import { createRequestOption } from '../../shared/util';

@Injectable({ providedIn: 'root' })
export class UserService {
  public resourceUrl = environment.SERVER_API_URL + 'api/users';
  public resourceSearchUrl = environment.SERVER_API_URL + 'api/public/search/users';
  constructor(private http: HttpClient) {}

  create(user: IUser): Observable<HttpResponse<IUser>> {
    return this.http.post<IUser>(this.resourceUrl, user, { observe: 'response' });
  }

  update(user: IUser): Observable<HttpResponse<IUser>> {
    return this.http.put<IUser>(this.resourceUrl, user, { observe: 'response' });
  }

  find(login: string): Observable<HttpResponse<IUser>> {
    return this.http.get<IUser>(`${this.resourceUrl}/${login}`, { observe: 'response' });
  }

  findById(id: number): Observable<HttpResponse<IUser>> {
    return this.http.get<IUser>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  query(req?: any): Observable<HttpResponse<IUser[]>> {
    const options = createRequestOption(req);
    return this.http.get<IUser[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  sendSMSVerification(profileId: any): Observable<HttpResponse<any>> {
    return this.http.get<any>(`${this.resourceUrl}/sms/sendSMSVerificationByAdmin/${profileId}`, { observe: 'response' });
  }

  sendEmailVerification(profileId: any): Observable<HttpResponse<any>> {
    return this.http.get<any>(`${this.resourceUrl}/sms/sendEmailVerification/${profileId}`, { observe: 'response' });
  }


  delete(login: string): Observable<HttpResponse<any>> {
    return this.http.delete(`${this.resourceUrl}/${login}`, { observe: 'response' });
  }

  deactivate(login: string): Observable<HttpResponse<any>> {
    return this.http.get(`${this.resourceUrl}/deactivate/${login}`, { observe: 'response' });
  }

  authorities(): Observable<string[]> {
    return this.http.get<string[]>(environment.SERVER_API_URL + 'api/users/authorities');
  }

  searchLogin(login: string): Observable<IUser[]> {
    return this.http.get<IUser[]>(this.resourceSearchUrl + `?login=${login}`);
  }
}
